import { useMemo, useState } from 'react';
import { useQuery } from '@apollo/client';
import {
  BehaviourProvider,
  OperationDetail,
} from '@facephi/inphinite-behaviour-module';
import {
  CardBase,
  FlexContainer,
  Label,
  Spinner,
  StatusBase,
  Switch,
} from '@facephi/ui-react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { StyledHeader } from './Styles';
import { useCiam } from '../../providers';
import { getUserLastOperation } from '../../state/queries/users';
import { EmptyData } from '../emptyData';

export const SecurityTab = () => {
  const { id } = useParams();
  const { t, i18n } = useTranslation();
  const { token, apiUrl } = useCiam();

  const [behaviourEmpty, setBehaviourEmpty] = useState<boolean>(false);

  const { data, loading } = useQuery(getUserLastOperation, {
    variables: {
      userId: id,
    },
  });

  const operationId = useMemo(
    () => data?.searchUserDetailOperations?.edges?.[0]?.node?.operationId,
    [data],
  );

  return (
    <>
      <FlexContainer
        flexDirection="column"
        rowGap="1.2"
        style={{ height: '100%' }}
      >
        <StyledHeader
          justifyContent="space-between"
          forwardedAs="section"
          columnGap="8.8"
          alignItems="center"
          style={{ marginBottom: '0.4rem' }}
        >
          <FlexContainer>
            <Label semibold fontSize="14">
              {t('Operations')}
            </Label>
          </FlexContainer>
          <FlexContainer columnGap="1.6" alignItems="center">
            <Label semibold fontSize="12">
              {t('Security profile')}:
            </Label>
            <Label semibold fontSize="12" color="purple400">
              {t('Careful')}
            </Label>
          </FlexContainer>
          <FlexContainer columnGap="1.6" alignItems="center">
            <Label semibold fontSize="12">
              {t('On a trip')}
            </Label>
            <Label semibold fontSize="12" color="purple400">
              {t('Argentina')}
            </Label>
          </FlexContainer>
          <FlexContainer columnGap="1.6" alignItems="center">
            <Label semibold fontSize="12">
              {t('Security alerts')}:
            </Label>
            <Switch />
          </FlexContainer>
          <StatusBase color="green400" label={t('connected') as string} />
        </StyledHeader>

        {loading ? (
          <Spinner insideComponent />
        ) : !operationId || behaviourEmpty ? (
          <CardBase flex="1">
            <EmptyData />
          </CardBase>
        ) : (
          <div style={{ padding: '1.3rem 0', height: '100%' }}>
            <BehaviourProvider
              language={i18n.language}
              companyId="Facephi-demo"
              apiUrl={apiUrl}
              token={token}
            >
              <OperationDetail
                operationId={operationId}
                onEmptyData={() => setBehaviourEmpty(true)}
                onExceptionError={() => setBehaviourEmpty(true)}
              />
            </BehaviourProvider>
          </div>
        )}
      </FlexContainer>
    </>
  );
};
